/**
 * Labstep
 *
 * @module components/Entity/Action/ViewAll
 * @desc Core view action
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { navigation } from 'labstep-web/services/navigation';
import type React from 'react';
import { Link } from 'react-router-dom';
import type { EntityActionViewAllProps } from './types';

export const EntityActionViewAll: React.FC<
  EntityActionViewAllProps
> = ({ entityName, params, actionComponentProps }) => {
  const pathname = navigation.get(`${entityName}_index`, params);

  return (
    <ActionComponent
      type="option"
      text="View All"
      elementProps={{ as: Link, to: { pathname } }}
      icon="eye"
      {...actionComponentProps}
    />
  );
};
